import { FC } from 'react';
import styled from 'styled-components';
import { motion } from 'motion/react';
import { Box } from '@comeon/ui';
import getCSSVarValue from '../utils/get-css-var-value';

const NO_CHANGES = 'NO_CHANGES';
const CHANGED = 'CHANGED';

const variants = {
	[NO_CHANGES]: {
		backgroundColor: getCSSVarValue('--main-background-sidebar'),
		borderColor: getCSSVarValue('--main-background-sidebar')
	},
	[CHANGED]: {
		backgroundColor: getCSSVarValue('--system-informative'),
		borderColor: getCSSVarValue('--system-informative')
	}
};

const Wrapper = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2px 6px;
	border-radius: var(--sportsbook-rounded-md);
`;

const LabelWrapper = styled.span`
	& > * {
		color: var(--main-text);
	}
`;

const AnimatedWrapper = motion(Wrapper);

type Props = {
	label?: string;
	children?: React.ReactNode;
	dataAt?: string;
	className?: string;
	isHighlighted: boolean;
};

const HighlightedLabel: FC<Props> = ({ label, children, dataAt, className, isHighlighted }) => {
	return (
		<AnimatedWrapper
			variants={variants}
			initial={NO_CHANGES}
			animate={isHighlighted ? CHANGED : NO_CHANGES}
			className={className}
		>
			<LabelWrapper data-at={dataAt}>{children || label || ''}</LabelWrapper>
		</AnimatedWrapper>
	);
};

export default HighlightedLabel;
